import { EmployeesService, DeclarationService, ApplicantsService, ApplicantStatusHistoryService, MasterdataAService } from '../../services';

export const hrState: aboTheme.IState = {
  parent: "app",
  name: "hr",
  url: "/hr",
  redirectTo: "hr.employees",
  component: "hrComponent",
  data: {
    permissions: {
      only: ['BACKOFFICE'],
      redirectTo: 'schedule'
    }
  }
};

export const hrDashboardState: aboTheme.IState = {

  name: "hr.dashboard",
  url: "/dashboard",
  views: {
    "main": 'hrDashboardComponent'
  }

};


export const employeesState: aboTheme.IState = {
  name: "hr.employees",
  url: "/employees",
  redirectTo: "hr.employees.list",
  views: {
    "main": "employeesComponent"
  }
};

export const employeesListState: aboTheme.IState = {
  name: "hr.employees.list",
  url: "/list",
  resolve: {
  },
  views: {
    "main": 'employeesListComponent'
  }
};

export const employeesItemState: aboTheme.IState = {
  name: "hr.employees.item",
  url: "/:id",
  params: {
    "tab": null
  },
  resolve: {
    tasks: (EmployeesService: EmployeesService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return EmployeesService.getChild($stateParams['id'], 'tasks'); } },
    notes: (EmployeesService: EmployeesService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return EmployeesService.getChild($stateParams['id'], 'notes', {sortfield: 'date', sortorder: 'DESC'}); } },
    employee: (EmployeesService: EmployeesService, $stateParams: ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return EmployeesService.get($stateParams['id']); } },
    history: (DeclarationService: DeclarationService, $stateParams: ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return DeclarationService.customAll('employee/' + $stateParams['id'] + '/summary'); } },
    employeeSkills: (EmployeesService: EmployeesService, $stateParams: ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return EmployeesService.getChild($stateParams['id'], 'skills'); } },
    functions: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('Functions');
    },
  },
  views: {
    "main": 'employeesItemComponent'
  }
};

export const employeesItemBasicState = {

  name: "hr.employees.item.basic",
  url: "/basic",
  params: {
    "tab": null
  },
  modal: ['employee'],
  size: "lg",
  resolve: {
    functions: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('Functions');
    },
    transportationTypes: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('TransportationType');
    },
    salaryScales: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('WageCodes');
    }
  },
  component: 'employeesItemBasicComponent'

};

export const shiftsItemState: aboTheme.IState = {

  name: "hr.employees.item.shift",
  url: "/shift/:shiftId",
  params: {
    "shiftId": null
  },
  modal: ['employee', 'shifts'],
  resolve: {
  },
  component: 'shiftsItemComponent'

};

export const availabilityItemState: aboTheme.IState = {

  name: "hr.employees.item.availability",
  url: "/availability/:employeeId/:availabilityId",
  params: {
    "availabilityId": null
  },
  modal: [],
  resolve: {
    statuses: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('AvalabilityStatus');
    }
  },
  component: 'availabilityItemComponent'

};

export const skillsItemState: aboTheme.IState = {

  name: "hr.employees.item.skill",
  url: "/skill/:employeeSkillId",
  params: {
    "employeeSkillId": null
  },
  modal: ['employee', 'employeeSkills'],
  resolve: {
    skills: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('Skills');
    }
  },
  component: 'skillsItemComponent'

};

export const availabilityListState: aboTheme.IState = {
  name: "hr.availability",
  url: "/availability",
  resolve: {
    avalabilityStatuses: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('AvalabilityStatus');
    },
  },
  views: {
    "main": 'availabilityListComponent'
  }
};

export const applicantsState: aboTheme.IState = {
  name: "hr.applicants",
  url: "/applicants",
  redirectTo: "hr.applicants.list",
  views: {
    "main": "applicantsComponent"
  }
};

export const applicantsListState: aboTheme.IState = {
  name: "hr.applicants.list",
  url: "/list?status&recruiter&function&targetaudiance",
  params: {
    "status": null,
    "recruiter": null,
    "function" : null,
    "targetaudiance": null,
  },
  resolve: {
    functions: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('Functions');
    },
    preferredTargetAudiences: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('PreferredTargetAudience');
    },
    applicationStatuses: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('ApplicationStatus');
    },
    users: (EmployeesService: EmployeesService) => { 'ngInject'; return EmployeesService.gatBackoffice(); },
  },
  views: {
    "main": 'applicantsListComponent'
  }
};

export const applicantsArchiveState: aboTheme.IState = {
  name: "hr.applicants.archive",
  url: "/archive?status&recruiter&function&targetaudiance",
  params: {
    "status": null,
    "recruiter": null,
    "function" : null,
    "targetaudiance": null,
    "archive": true
  },
  resolve: {
    functions: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('Functions');
    },
    preferredTargetAudiences: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('PreferredTargetAudience');
    },
    applicationStatuses: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('ApplicationStatus');
    },
    users: (EmployeesService: EmployeesService) => { 'ngInject'; return EmployeesService.gatBackoffice(); }
  },
  views: {
    "main": 'applicantsListComponent'
  }
};

export const applicantsItemState: aboTheme.IState = {
  name: "hr.applicants.item",
  url: "/:id",
  params: {
    "tab": null
  },
  resolve: {
    applicant: (ApplicantsService: ApplicantsService, $stateParams: ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return ApplicantsService.get($stateParams['id']); } },
    notes: (ApplicantsService: ApplicantsService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return ApplicantsService.getChild($stateParams['id'], 'notes', {sortfield: 'date', sortorder: 'DESC'}); } },
    applicationStatusHistories: (ApplicantStatusHistoryService: ApplicantStatusHistoryService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return ApplicantStatusHistoryService.getPerApplicant($stateParams['id']); } },
    functions: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('Functions');
    },
    preferredTargetAudiences: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('PreferredTargetAudience');
    },
    applicationStatuses: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('ApplicationStatus');
    },
    users: (EmployeesService: EmployeesService) => { 'ngInject'; return EmployeesService.gatBackoffice(); },
  },
  views: {
    "main": 'applicantsItemComponent'
  }
};

export const applicantsArchiveItemState: aboTheme.IState = {
  name: "hr.applicants.archiveitem",
  url: "/archive/:id",
  params: {
    "tab": null,
    "archive": true
  },
  resolve: {
    applicant: (ApplicantsService: ApplicantsService, $stateParams: ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return ApplicantsService.get($stateParams['id']); } },
    notes: (ApplicantsService: ApplicantsService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return ApplicantsService.getChild($stateParams['id'], 'notes', {sortfield: 'date', sortorder: 'DESC'}); } },
    applicationStatusHistories: (ApplicantStatusHistoryService: ApplicantStatusHistoryService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return ApplicantStatusHistoryService.getPerApplicant($stateParams['id']); } },
    functions: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('Functions');
    },
    preferredTargetAudiences: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('PreferredTargetAudience');
    },
    applicationStatuses: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('ApplicationStatus');
    },
    users: (EmployeesService: EmployeesService) => { 'ngInject'; return EmployeesService.gatBackoffice(); },
  },
  views: {
    "main": 'applicantsItemComponent'
  }
};

export const applicantsItemBasicState: aboTheme.IState = {

  name: "hr.applicants.item.basic",
  url: "/basic",
  params: {
    "tab": null
  },
  modal: ['applicant', 'users'],
  resolve: {
    functions: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('Functions');
    },
    preferredTargetAudiences: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('PreferredTargetAudience');
    },
    applicationStatuses: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('ApplicationStatus');
    },
   
  },
  component: 'applicantsItemBasicComponent'

};

export const applicantsArchiveItemBasicState: aboTheme.IState = {

  name: "hr.applicants.archiveitem.basic",
  url: "/basic",
  params: {
    "tab": null,
    "archive": true
  },
  modal: ['applicant', 'users'],
  resolve: {
    functions: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('Functions');
    },
    preferredTargetAudiences: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('PreferredTargetAudience');
    },
    applicationStatuses: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('ApplicationStatus');
    },
   
  },
  component: 'applicantsItemBasicComponent'

};


export const applicantsItemEmployeeState: aboTheme.IState = {

  name: "hr.applicants.item.employee",
  url: "/employee",
  params: {
    "tab": null
  },
  modal: ['applicant'],
  resolve: {
    functions: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('Functions');
    },
    applicationStatuses: (MasterdataAService: MasterdataAService) => {
      'ngInject';
      return MasterdataAService.getItems('ApplicationStatus');
    }
  },
  component: 'applicantsItemEmployeeComponent'

};


// WEBPACK FOOTER //
// ./src/app/modules/hr/hr.states.ts